<template lang="pug">
  v-container(fill-height)
    v-layout(row, wrap, align-center)
      v-flex(md6, offset-md3)

        v-card
          v-card-title(primary-title='')
            h3.headline.mb-0 Create an Account
          v-card-text
            v-form
              v-text-field(v-model='C.form.selected.account.name', label='Name', required='')
              v-text-field(v-model='C.form.selected.account.email', label='E-mail', required='')
              v-text-field(v-model='C.form.selected.account.password', label='Password', type='password', hint='At least 8 characters', min='8', counter='', required='')
              v-text-field(v-model='C.form.selected.account.confirm_password', label='Confirm password', type='password', hint='At least 8 characters', min='8', counter='', required='')
          v-card-text
            v-btn.cyan(@click='C.form.trigger.submit', block, large, color='primary') Sign up
        p.pa-3.text-xs-center
          | Have a login? 
          router-link(to='signin')
            | Login here
          |.
</template>

<script>
import axios from '../../../node_modules/axios/dist/axios.js'

export default {
  data () {
    return {
      C: {
        form: {
          selected: {
            account: {
              name: '',
              email: '',
              password: '',
              confirm_password: ''
            }
          },
          trigger: {
            submit: () => {
              var component = this

              var submitItem = {
                name: this.C.form.selected.account.name,
                email: this.C.form.selected.account.email,
                password: this.C.form.selected.account.password,
                confirm_password: this.C.form.selected.account.confirm_password
              }

              axios.post(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/users/create_account`, submitItem)
              .then(function (response) {
                console.info('Create Account Results: ', response.data)

                component.$router.push({
                  name: 'SignIn'
                })
              })
              .catch(function (errorResponse) {
                console.error('errorResponse', errorResponse)
              })
            }
          }
        }
      }
    }
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Authentication/PasswordSignUp.vue